(function ($) {
  Drupal.behaviors.contactUsForm = {
    attach: function (context, settings) {
      var $contactForm = $('.contact-form', context);
      var $confirmation = $('.contact-form-confirm', context);
      var $questionTypes = $('.contact-form__section--question-types', $contactForm);
      var $radios = $('input[type=radio]', $questionTypes);
      var $questionTypeField = $('.contact-form__question-type-field', $contactForm);
      var $addressForm = $('.address-form', $contactForm);
      var $addressFields = $('.address-form__address-fields', $addressForm);
      var isMobile = $('body').hasClass('device-mobile');
      var $requiresAddressFields = $('#require_address_regex', $contactForm);
      var addressRequiredQuestions = $requiresAddressFields.val() || '^(7|8|14|15)$';
      var requiresAddressRegex = new RegExp(addressRequiredQuestions);

      if ($requiresAddressFields.hasClass('require_address_for_all')) {
        $addressFields.addClass('required');
        _setRequiredPlaceholders(true);
      }

      function _changeRadio() {
        // If a radio changes, iterate through all radios and show any relavent
        // sub-elements.
        $radios.each(function () {
          var id = $(this).attr('id');

          $('[data-cf-show-if=' + id + ']', $contactForm).toggle($(this).is(':checked'));
          // Because we're using nested radios we have to control the actual
          // QUESTION field with JS
          if ($(this).is(':checked')) {
            $questionTypeField.val($(this).val());
            if (!$requiresAddressFields.hasClass('require_address_for_all')) {
              if (requiresAddressRegex.test($(this).val())) {
                $addressFields.addClass('required');
                _setRequiredPlaceholders(true);
              } else {
                $addressFields.removeClass('required');
                _setRequiredPlaceholders();
              }
            }
          }
        });
      }

      function _setRequiredPlaceholders(required) {
        if (!isMobile) {
          return;
        }
        $('.required-field', $addressFields).each(function () {
          var placeholder = $(this).attr('placeholder').replace('* ', '');
          var newPlaceholder = required ? '* ' + placeholder : placeholder;

          $(this).attr('placeholder', newPlaceholder);
        });
        $('select.required-select', $addressFields).each(function () {
          var $firstOption = $('option', this).first();
          var placeholder = $firstOption.text().replace('* ', '');
          var newPlaceholder = required ? '* ' + placeholder : placeholder;

          $firstOption.text(newPlaceholder);
        });
      }

      $radios.on('change', _changeRadio);

      $contactForm.on('submit', function (event) {
        event.preventDefault();
        $(".contact-form input[type='submit']").prop('disabled', true);
        $('.field').removeClass('error');
        // Put the form values into an object
        var paramArr = $contactForm.serializeArray();
        var paramObj = {};

        $.each(paramArr, function (index, param) {
          paramObj[param.name] = param.value;
        });

        generic.jsonrpc.fetch({
          method: 'rpc.form',
          params: [paramObj],
          onSuccess: function (jsonRpcResponse) {
            $contactForm.add($confirmation).toggle();
          },
          onFailure: function (jsonRpcResponse) {
            var errorObjectsArray = jsonRpcResponse.getMessages();

            generic.showErrors(errorObjectsArray);
            for (var i = 0; i < errorObjectsArray.length; i++) {
              for (var j = 2; j < errorObjectsArray[i].tags.length; j++) {
                var fieldTags = errorObjectsArray[i].tags[j].substr(6).toUpperCase();

                $("[name='" + fieldTags + "']").addClass('error');
              }
            }
            $('html, body').animate({ scrollTop: $('.cs-quick-info').offset().top + 'px' }, 'fast');
            if ($('.error_messages_display').is(':visible') === true) {
              $(".contact-form input[type='submit']").prop('disabled', false);
            }
          }
        });
      });

      _changeRadio();
    }
  };
})(jQuery);
